module.exports = __webpack_public_path__ + "img/new int icon.5c1e0a44.svg";